/** @file clipMenu: the right-click menu of the clip list, a thin builder over the shell's menu registry. */
import type { EditorStore, MenuItem } from '../../state/editorTypes';
import { buildMenu } from '../../shell/menu/buildMenu';

/** The list's inline editors the menu opens, and the yes/no prompt for Delete. */
export type ClipMenuUi = { rename: (clip: string) => void; meta: (clip: string) => void; confirm: (text: string) => boolean };

/** Items for clip `name` (null = empty space: New clip only); `category` seeds a new clip's category. */
export function clipMenu(store: EditorStore, name: string | null, category: string, ui: ClipMenuUi): MenuItem[] {
  return buildMenu('clip', { store, surface: 'timeline', clip: name, category, ui });
}
